var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtB5Hov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4653 9.16439C82.6657 14.6476 102.083 19.1803 100.49 42.5908C99.6525 54.9022 92.1659 81.3582 78.1657 94.2181C68.7588 108.058 49.7028 103.77 38.9198 102.988C16.1759 101.338 14.5164 75.3692 16.1095 51.9587C17.7026 28.5483 37.7214 7.51424 60.4653 9.16439Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6987 51.748C32.5613 53.6666 35.1491 57.5921 38.5994 57.9463C42.9124 58.3891 63.1833 57.9463 64.9084 57.9463C66.2886 57.9463 68.0713 56.7657 68.7901 56.1754",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7892 73.4912C96.0076 73.4912 99.4865 70.4671 99.4865 67.4431C99.4865 64.419 99.0517 59.2349 90.7892 57.0749C82.5268 54.9148 80.7874 55.3468 70.3506 48.4347C59.9139 41.5225 52.9561 43.2505 44.2588 42.8185C35.5615 42.3865 26.8642 48.0026 24.255 50.5947C22.1677 52.6683 19.0366 53.4747 17.732 53.6187C15.9926 53.6187 12.5137 55.0012 12.5137 60.5309C12.5137 66.0607 15.4128 70.0351 16.8623 71.3312",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6353 68.0743C25.1049 66.2255 29.0861 63.0826 33.2543 65.3011C38.4646 68.0743 38.8654 73.6205 37.2622 76.3937C35.6591 79.1669 29.2464 81.5439 25.6393 78.3745C22.7536 75.8391 22.5665 72.0359 22.8337 70.4512",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6406 65.4446C73.132 65.5993 71.3393 70.0784 71.0065 72.2987L71.4787 74.6361C72.0147 76.0675 73.9862 79.1092 77.5851 79.8249C82.0837 80.7194 86.2541 75.7152 86.2558 72.6706C86.2575 69.626 83.2764 65.2512 77.6406 65.4446Z",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3334 71.5552C59.526 71.5552 47.0401 71.5552 43.5557 71.5552",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7211 24.8887L50.8838 31.2837H57.2788L53.4417 37.6788",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtB5Hov);
export default __webpack_public_path__ + "static/media/vt_b5_hov.a435a8b90b1cf33bd46092cb211f70e2.svg";
export { ForwardRef as ReactComponent };